<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
  <section id="maingroupcut">
    <div class="col-md-12">
      <div class="row">
        <div class="card">
          <div class="card-header bg-success">ข้อมูล ใบคิวปีการผลิต {{yearselect.year_th}}</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-auto">
                <ul class="nav nav-tabs mb-3" id="vert-tabs-tab" role="tablist" aria-orientation="horizontal">
                  <li class="nav-item " role="presentation">
                    <a class="nav-item nav-link active" id="tabs-tab3" (click)="change_search(1);" data-toggle="pill">
                      <p style="font-weight: bold;">ค้นตามโควตา</p>
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-item nav-link" id="tabs-tab2" (click)="change_search(2);" data-toggle="pill">
                      <p style="font-weight: bold;">ค้นตามเลขกลุ่มตัด</p>
                    </a>
                  </li>
                  <li class="nav-item" role="presentation">
                    <a class="nav-item nav-link" id="tabs-tab2" (click)="change_search(3);" data-toggle="pill">
                      <p style="font-weight: bold;">ค้นตามทะเบียนรถ</p>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-md-3">
                <!--<div class="input-group mb-3" [formGroup]="Formdata">
                  <span class="input-group-text" id="basic-addon2">{{textshow1}}</span>
                  <input type="text" class="form-control" maxlength="10" id="txtsearch" formControlName="fmdata"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                  <button mat-raised-button color="warn" (click)="Loaddatabyzone();">ค้นหา</button>
                </div>-->
                <div class="input-group mb-3">
                  <span class="input-group-text" id="addon2">{{textshow1}}</span>
                  <input type="text" class="form-control" [(ngModel)]="txtSearch" aria-label="Recipient's username"
                    aria-describedby="addon2" name="txtSearch">
                  <button class="btn btn-outline-secondary" type="button" id="addon2"
                    (click)="Loaddatabyzone();">ค้นหา</button>
                </div>
              </div>
              <div class="col-md-3">
                <div class="input-group mb-2" *ngIf="data_in.length>0">
                  <span class="input-group-text" id="basic-addon2">เลือกดูสถานะคิว</span>
                  <select class="form-select" [(ngModel)]="filterbytype" (change)="Selectbytype();">
                    <option value=null>-- ข้อมูลทั้งหมด --</option>
                    <option value=0>ยังไม่จองคิว</option>
                    <option value=1>จองคิวแล้ว</option>
                    <option value=3>แจ้งคิวแล้ว</option>
                    <option value=4>เข้าชั่งแล้ว</option>
                    <option value=5>ชั่งออกแล้ว</option>
                  </select>
                  <span class="input-group-text" *ngIf="DataBZL!= null">พบ {{DataBZL}} รายการ</span>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header d-flex p-0">
                <!--<h3 class="card-title p-3">******************</h3>-->
              </div>
              <div class="card-body">
                <div class="tab-content">
                  <div class="tab-pane active">
                    <div class="row">
                      <div class="card-body table-responsive p-2" style="height: 550px">
                        <table #tb_data class="table table-hover table-striped table-head-fixed text-nowrap">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">โซน</th>
                              <th scope="col">เลขใบคิว</th>
                              <th scope="col">รอบ</th>
                              <th scope="col">คิวที่</th>
                              <th scope="col">หมายเลขแปลง</th>
                              <th scope="col">ชื่อ</th>
                              <th scope="col">กลุ่ม</th>
                              <th scope="col">พื้นที่</th>
                              <th scope="col">ทะเบียนรถ</th>
                              <th scope="col">ประเภทคิว</th>
                              <th scope="col">สถานะคิว</th>
                              <th scope="col">เวลาจองคิว</th>
                              <th scope="col">เวลาแจ้งคิว</th>
                              <th scope="col">อ้อยสด/ไฟ</th>
                              <th scope="col">อ้อยเข้า</th>
                              <th scope="col">CCS</th>
                              <th scope="col">งวดวันที่</th>
                              <th scope="col">ค่าน้ำมัน</th>
                              <th scope="col">ค่าอ้อย</th>

                              <!--<th style="text-align:center"  scope="col">กลุ่มตัด</th>                                        
                                        <th style="text-align:center"  scope="col">ยืนยันพื้นที่</th>
                                        <th scope="col">Action</th>!-->
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of DataByZone; let i = index">
                              <td>{{i+1}}</td>
                              <td>{{item.supzone}}</td>
                              <td>{{item.truck_q}}</td>
                              <td>{{item.ref_doc1}}</td>
                              <td>{{item.q_id}}</td>
                              <td>{{item.landno}}</td>
                              <td>{{item.fmname}}</td>
                              <td>{{item.groupcodeQ}}</td>
                              <td>{{item.landvalue | number}}</td>
                              <td>{{item.regtruck}}</td>
                              <td>{{item.qdesc}}</td>
                              <td>{{item.q_desc}}</td>
                              <td>{{THtoLocalstring(item.booktime)}}</td>
                              <td>{{THtoLocalstring(item.date_in)}}</td>

                              <td>{{item.cane_name}}</td>
                              <td style="text-align: right;">{{item.wgt_net | number}}</td>
                              <td style="text-align: right;">{{item.ccs_value}}</td>
                              <td>{{item.reportdate | date}}</td>
                              <td style="text-align: right;">{{item.oil_amount | number}}</td>
                              <td style="text-align: right;">{{item.cane_amt | number}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer></app-footer>